export function log(value, message = 'debug: ', ...extra) {
    console.log(message, value, ...extra);

    return value;
}